const colores = {
  rojo: "#E3000B",
  grisOscuro: "#666",
  grisClaro: "#ACAFB0",
  title: "#2b323c",
  azulOscuro: "#022A3A",
  azulConsulSteel: "#0C24F9",
  naranjaConsulSteel: "#B3BC00",
  celeste: "#4FD0FC",
  activo: "#39FF88",
  inactivo: "#F3E72C",
  rechazado: "#E22022",
  white: "#FFF",
};
export default {
  ...colores,
};
